import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import ReactModal from "react-modal";
import UserContext from "../../../contexts/UserContext";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import IZenDeskCreateTicketDTO from "../../../models/DTO/IZenDeskCreateTicketDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import { Socket } from "socket.io-client";

type Props = {
    closeModal: () => void;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
};

export const CreateTicketModal: React.FC<Props> = (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(true);
    const [modalStyle, setModalStyle] = useState({
        overlay: {
            zIndex: 999999999,
        },
        content: {},
    });
    const [submitActive, setSubmitActive] = useState(false);
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [otherSubject, setOtherSubject] = useState("");

    const subjectOptions = [
        { title: "Something doesn't work right." },
        { title: "Not sure what to do." },
        { title: "Something is out of place." },
        { title: "Other" },
    ];

    const userModel = useContext(UserContext);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "message":
                setMessage(value);
                break;

            case "subject":
                setSubject(value);
                break;
        }
    };

    useEffect(() => {
        props.socket.on(EndpointsEnum.ZenDeskOnCreateTicket, onCreateSupportTicket);

        return () => {
            props.socket.removeListener(EndpointsEnum.ZenDeskOnCreateTicket, onCreateSupportTicket);
        };
    }, []);

    const createSupportTicket = () => {
        const payload: IZenDeskCreateTicketDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: "",
            commentBody: message,
            subject,
        };

        if (subject === "Other" && otherSubject.length) {
            payload.subject = otherSubject;
        }

        props.socket.emit(EndpointsEnum.ZenDeskCreateTicket, payload);

        setSubmitActive(true);
    };

    const onCreateSupportTicket = () => {
        const notification: INotification = {
            title: "successfully_created_support_ticket",
            message: "check_email_for_details",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        props.notifyFn(null, notification);

        setSubmitActive(false);

        props.closeModal();
    };

    const handleOtherSubject = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        setOtherSubject(value);
    };

    return (
        <div className={"CreateTicketModal"}>
            <ReactModal
                isOpen={modalIsOpen}
                contentLabel="Create Support Ticket"
                style={modalStyle}
                className={"modalClass"}
                overlayClassName={"overlayClass"}>
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-12 d-flex justify-content-between"}>
                            <OwTitle className={"d-inline-flex"} tag={"h2"} title={"support_ticket"} />
                            <div>
                                <OwButton
                                    leftIconClass={"fas fa-times"}
                                    className={"align-items-center btn-sm btn-danger d-inline-flex ms-auto"}
                                    fn={props.closeModal}
                                    title={"close"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12 text-small text-muted"}>
                            <OwTranslate defaultMessage={"support_ticket_req_info"} id={"support_ticket_req_info"} />
                            <span className={"ms-1"}>{userModel ? userModel.email : ""}</span>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div>
                                <OwLabel title={"type"} showIsReqAsterik={true} />
                            </div>
                            <div>
                                <OwSelectOption
                                    name={"subject"}
                                    fn={handleChange}
                                    titleProp={"title"}
                                    valueProp={"title"}
                                    options={subjectOptions}
                                />
                            </div>
                            {subject === "Other" ? (
                                <div className={"mt-3"}>
                                    <OwInputWrapper name={"otherSubject"} fn={handleOtherSubject} value={otherSubject} />
                                </div>
                            ) : null}
                        </div>

                        <div className={"col-12 mt-3"}>
                            <div>
                                <OwLabel title={"message"} showIsReqAsterik={true} />
                            </div>
                            <div>
                                <OwTextArea name={"message"} value={message} fn={handleChange} placeholder={"message"} />
                            </div>
                        </div>
                    </div>
                    <div className={"row mt-2"}>
                        <div className={"col-12"}>
                            <OwButton
                                disabled={submitActive}
                                active={submitActive}
                                fn={createSupportTicket}
                                title={"submit"}
                                leftIconClass={"fas fa-plus"}
                            />
                        </div>
                    </div>
                </div>
            </ReactModal>
        </div>
    );
};
